import React from 'react'

const BannerArrowDown = () => {
  return (
    <path fill="none" fillRule="evenodd" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.4" d="M2 2l18.95 11L39.9 2" />
  )
}

export default BannerArrowDown
